import React, { Dispatch, useCallback } from 'react';

import { down } from '@/assets/icons';
import { Scrollbar } from '@/components/Scrollbar';
import { ContentCard } from '@/components/shared/ContentCard';
import { Video, VideoCollection } from '@/graphql';
import { ButtonBase, SvgIcon } from '@material-ui/core';

import styles from './UpNext.module.scss';
import { UpNextChip } from './UpNextChip';

export interface IUpNextProps {
	variant: 'mobile' | 'desktop';
	videos: Video[];
	currentlyWatched?: string;
	collectionName?: string;
	open?: boolean;
	setOpen?: Dispatch<boolean>;
}

export const UpNext: React.FC<IUpNextProps> = ({
	variant,
	videos,
	currentlyWatched,
	collectionName,
	open,
	setOpen,
}) => {
	const handleScroll = useCallback((node: HTMLInputElement) => {
		setTimeout(function () {
			node?.scrollIntoView({ behavior: 'smooth' });
		}, 100);
	}, []);

	if (!videos) {
		return null;
	}

	const upNextClasses = [
		styles['up-next'],
		styles[`up-next--${variant}`],
		open && styles['up-next--open'],
	];
	const iconClasses = [
		styles['up-next__icon'],
		!open && styles['up-next__icon--rotated'],
	];

	return (
		<div className={upNextClasses.join(' ')}>
			<div className={styles['up-next__header']}>
				{variant === 'mobile' && setOpen ? (
					<ButtonBase
						onClick={() => setOpen(!open)}
						className={styles['up-next__button']}
					>
						<h3>
							Up Next{' '}
							<SvgIcon
								component={down}
								className={iconClasses.join(' ')}
							/>
						</h3>
					</ButtonBase>
				) : (
					<h3>Up Next</h3>
				)}
				{(variant === 'desktop' || open) && <h2>{collectionName}</h2>}
			</div>
			{(variant === 'desktop' || open) && (
				<Scrollbar className={styles['up-next__content']}>
					{variant === 'desktop'
						? videos.map((video) => (
								<div
									ref={
										video.id === currentlyWatched
											? handleScroll
											: null
									}
									key={video.id}
								>
									<UpNextChip
										video={video}
										currentlyWatched={
											video.id === currentlyWatched
										}
										link={`/videos/${video.id}`}
									/>
								</div>
						  ))
						: videos.map((video) => (
								<div
									ref={
										video.id === currentlyWatched
											? handleScroll
											: null
									}
									key={video.id}
									className={styles['up-next__item-wrapper']}
								>
									<div className={styles['up-next__item']}>
										<ContentCard
											video={video}
											outlined={
												video.id === currentlyWatched
											}
											link={`/videos/${video.id}`}
										/>
									</div>
								</div>
						  ))}
				</Scrollbar>
			)}
		</div>
	);
};
